import { useContext, useState } from "react";
import CTypography from "../../../componets/typography";
import { CustomCursorContext } from "../../../contexts/cursor";
import { AccordionItem } from "./connector-accordion-styled";

/* Single-expand, collapsible, keyed by title — the same contract as the site's
   CAccordions, without the component library. `title` must be unique. */
export const ConnectorAccordion = ({ accordionOptions }) => {
  const [expanded, setExpanded] = useState("");
  const { setType } = useContext(CustomCursorContext);

  return accordionOptions?.map?.(({ title, body }) => (
    <AccordionItem
      key={title}
      open={expanded === title}
      onToggle={(event) => {
        // Closing the previously open panel also fires `toggle`, and it fires
        // after the one that opened this panel — so a naive handler would
        // immediately clear the selection. Only the panel that owns the
        // selection is allowed to clear it.
        if (event.currentTarget.open) {
          setExpanded(title);
        } else {
          setExpanded((previous) => (previous === title ? "" : previous));
        }
      }}
    >
      <summary
        onMouseEnter={() => {
          setType("hover");
        }}
        onMouseLeave={() => {
          setType("");
        }}
      >
        <CTypography
          weight="medium"
          size="largest"
          color="var(--Black)"
          className="black-acc-title"
        >
          {title}
        </CTypography>
        <span className="chevron" aria-hidden="true" />
      </summary>
      <div className="acc-body">
        <CTypography
          weight="medium"
          size="large"
          color="var(--Grey)"
          className="grey-body"
        >
          {body}
        </CTypography>
      </div>
    </AccordionItem>
  ));
};
